import {
  CurriculaVMModel,
  CurriculumViewListing,
  SelectedCurriculumModel,
  StudentCourseModel,
  StudentModel,
  StandardsGrowthReportModel,
} from 'src/app/Elearning-Models';


export class CurriculumServiceMockValues {



  public curriculumData: CurriculaVMModel = {
   // UserCurriculumCredits: 1,
   IsTeacher: true,
    Grades: [
      {
        Subjects: [
          {
            Curriculums: [
              {
                CurriculumID: 10,
                CurriculumName: 'Math',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'Math',
          },
          {
            Curriculums: [
              {
                CurriculumID: 12,
                CurriculumName: 'ELA',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'ELA',
          },
        ],
        ConsumerGradeName: 'Grade 1',
      },
      {
        Subjects: [
          {
            Curriculums: [
              {
                CurriculumID: 11,
                CurriculumName: 'Math',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'Math',
          },
          {
            Curriculums: [
              {
                CurriculumID: 13,
                CurriculumName: 'ELA',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'ELA',
          },
        ],
        ConsumerGradeName: 'Grade 2',
      },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 3',
       },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 4',
       },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 5',
       },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 6',
       },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 7',
       },{
         Subjects: [
           {
             Curriculums: [
               {
                 CurriculumID: 10,
                 CurriculumName: 'Math',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'Math',
           },
           {
             Curriculums: [
               {
                 CurriculumID: 12,
                 CurriculumName: 'ELA',
                 Price: '$15.00',
                 CurriculumDesc: 'This curriculum will give you what youneed.',
                 ImagePath: 'ElemEnglish.jpg'
               },
             ],
             ConsumerSubjectName: 'ELA',
           },
         ],
         ConsumerGradeName: 'Grade 8',
       },
      {
        Subjects: [
          {
            Curriculums: [
              {
                CurriculumID: 1,
                CurriculumName: 'Algebra 1',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
              {
                CurriculumID: 2,
                CurriculumName: 'Algebra 2',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
              {
                CurriculumID: 3,
                CurriculumName: 'Geometry 3',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
              {
                CurriculumID: 4,
                CurriculumName: 'Calculus 1',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'Math',
          },
          {
            Curriculums: [
              {
                CurriculumID: 5,
                CurriculumName: 'ELA 1',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
              {
                CurriculumID: 6,
                CurriculumName: 'ELA 2',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
              {
                CurriculumID: 7,
                CurriculumName: 'ELA 3',
                Price: '$15.00',
                CurriculumDesc: 'This curriculum will give you what youneed.',
                ImagePath: 'ElemEnglish.jpg'
              },
            ],
            ConsumerSubjectName: 'ELA',
          },
        ],
        ConsumerGradeName: 'High School',
      },
    ],
  };

  public studentData: StudentModel[] = [
    {
      StudentID: 1,
      StudentFirstName: 'Student',
      StudentLastName: 'S1',
      StudentEmail: 'student.s1@gmail.com',
    },
    {
      StudentID: 2,
      StudentFirstName: 'Student',
      StudentLastName: 'S2',
      StudentEmail: 'student.s2@gmail.com',
    },
    {
      StudentID: 3,
      StudentFirstName: 'Student',
      StudentLastName: 'S3',
      StudentEmail: 'student.s3@gmail.com',
    },
    {
      StudentID: 4,
      StudentFirstName: 'Student',
      StudentLastName: 'S4',
      StudentEmail: 'student.s4@gmail.com',
    },
    {
      StudentID: 5,
      StudentFirstName: 'Student',
      StudentLastName: 'S5',
      StudentEmail: 'student.s5@gmail.com',
    },
    {
      StudentID: 6,
      StudentFirstName: 'Student',
      StudentLastName: 'S6',
      StudentEmail: 'student.s6@gmail.com',
    },
    {
      StudentID: 7,
      StudentFirstName: 'Student',
      StudentLastName: 'S7',
      StudentEmail: 'student.s7@gmail.com',
    },
    {
      StudentID: 8,
      StudentFirstName: 'Student',
      StudentLastName: 'S8',
      StudentEmail: 'student.s8@gmail.com',
    },
    {
      StudentID: 9,
      StudentFirstName: 'AndAnEvenLongerLastNameHmmm',
      StudentLastName: 'ALongFirstNamePerhaps',
      StudentEmail: 'student.s9@gmail.com',
    },
  ];

  public selectedCurriculumData: SelectedCurriculumModel = {
    CurriculumID: 10,
    CurriculumName: 'Math',
    Price: '$15.00',
    HasUnitTests: true,
    LessonCount: 30, 
    ImagePath: 'ElemEnglish.jpg',
    CurriculumDesc:
      'This curriculum will give you depth knowledge about Basic Maths which include tpoics like Addition, Subtraction, Multiplication, Division etc. This curriculum will give you depth knowledge about Basic Maths which include tpoics like Addition, Subtraction, Multiplication, Division etc.',
  };

  public studentCourseData: StudentCourseModel = {
    IsTeacher: true,
    StudentCurriculums: [
      {
        StudentFirstName: 'Losee',
        StudentLastName: 'Zach',
        StudentID: 727445,
        ClassID: 1001592,
        ClassName: 'CR 1 Geometry',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },{
         StudentFirstName: 'Losee',
         StudentLastName: 'Zach',
         StudentID: 727445,
         ClassID: 10015592,
         ClassName: 'NEW CR 1 Geometry',
         HasPaid: true,
         HasCompletedDemo: true,
         ImagePath: 'ElemEnglish.jpg'
       },
      {
        StudentFirstName: 'Camp',
        StudentLastName: 'Tyler',
        StudentID: 811635,
        ClassID: 1001597,
        ClassName: 'CR 1 Physical ED Credit recovery',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Student',
        StudentLastName: 'S1',
        StudentID: 891485,
        ClassID: 1001596,
        ClassName: 'CR- 1 Weather and Astronomy',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Jim',
        StudentLastName: 'Hook',
        StudentID: 811637,
        ClassID: 1001593,
        ClassName: 'CR -2 Math & Finance',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Harry',
        StudentLastName: 'Davidson',
        StudentID: 811636,
        ClassID: 1001591,
        ClassName: 'CR 3 Algebra',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Asma',
        StudentLastName: 'Iqbal',
        StudentID: 811638,
        ClassID: 1001595,
        ClassName: 'CR 4- Living environment',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Chris',
        StudentLastName: 'Bandit',
        StudentID: 811639,
        ClassID: 1011286,
        ClassName: 'CR Algebra 11 and Trig',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Wes',
        StudentLastName: 'Benson',
        StudentID: 811640,
        ClassID: 1011284,
        ClassName: 'CR CC Algebra I',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Derek ',
        StudentLastName: 'Manino',
        StudentID: 811641,
        ClassID: 1011289,
        ClassName: 'Profit And Loss',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Dens ',
        StudentLastName: 'Manino',
        StudentID: 811642,
        ClassID: 1011290,
        ClassName: 'CR CC Algebra II',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Bob ',
        StudentLastName: 'Marley',
        StudentID: 811643,
        ClassID: 1011291,
        ClassName: 'Algorithm',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
      {
        StudentFirstName: 'Bob ',
        StudentLastName: 'Builder',
        StudentID: 811644,
        ClassID: 1011292,
        ClassName: 'Trignometry',
        HasPaid: true,
        HasCompletedDemo: true,
        ImagePath: 'ElemEnglish.jpg'
      },
    ],
  };
 

   public currViewData: CurriculumViewListing = {
      "IsTeacher":true,
      "HBFullName":"Grade 6 English",
      "HasDemoCompleted":false,
      "HasLessonMax":false,
      "HasCompletedPreCourseDiagnostic":false,
      "HBClassID":1093360,
      "StudentFullName":"Jackie Brown",
      "StudentID":909451,
      "Groups":[
         {
            "Sequence":0,
            "GroupName":"Pre-Course Diagnostic",
            "Hide":false,
            "Items":[
               {
                  "Sequence":1,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Grade 6 ELA Diagnostic",
                  "CurriculumItemID":1022082,
                  "AssignmentID":null,
                  "LessonID":130754,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":[{
                     
                        SentBack: false,
                        Graded: true,
                        SubmittedAsComplete: true,
                        Grade: "50",
                        AttemptID: 111,
                        Status: "Graded",
                        CompleteDate: "11/11/11",
                        CurriculumItemID: 1,
                        Sequence: 1,
                        AssignmentID: 2,
                        LessonID: 22,
                        LessonName: "It's a name"
                     
                  }],
                  "IsDiagnosticExam": true,
                  StudentConsumerCurriculumID: 1,
                  "StandardsGrowth":[
                     {
                        "StandardID":1217181,
                        "StandardName":"RL.6.1",
                        "StandardDescription":"Cite textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1217182,
                        "StandardName":"RL.6.2",
                        "StandardDescription":"Determine a theme or central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1217183,
                        "StandardName":"RL.6.3",
                        "StandardDescription":"Describe how a particular story's or drama's plot unfolds in a series of episodes as well as how the characters respond or change as the plot moves toward a resolution.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218163,
                        "StandardName":"L.6.1a",
                        "StandardDescription":"Ensure that pronouns are in the proper case (subjective, objective, possessive).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218164,
                        "StandardName":"L.6.1b",
                        "StandardDescription":"Use intensive pronouns (e.g., myself, ourselves).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218165,
                        "StandardName":"L.6.1c",
                        "StandardDescription":"Recognize and correct inappropriate shifts in pronoun number and person.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218166,
                        "StandardName":"L.6.1d",
                        "StandardDescription":"Recognize and correct vague pronouns (i.e., ones with unclear or ambiguous antecedents).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218167,
                        "StandardName":"L.6.1e",
                        "StandardDescription":"Recognize variations from standard English in their own and others' writing and speaking, and identify and use strategies to improve expression in conventional language.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218169,
                        "StandardName":"L.6.2a",
                        "StandardDescription":"Use punctuation (commas, parentheses, dashes) to set off nonrestrictive/parenthetical elements.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218170,
                        "StandardName":"L.6.2b",
                        "StandardDescription":"Spell correctly.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218177,
                        "StandardName":"L.6.4a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218178,
                        "StandardName":"L.6.4b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218179,
                        "StandardName":"L.6.4c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218180,
                        "StandardName":"L.6.4d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218182,
                        "StandardName":"L.6.5a",
                        "StandardDescription":"Interpret figures of speech (e.g., personification) in context.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218183,
                        "StandardName":"L.6.5b",
                        "StandardDescription":"Use the relationship between particular words (e.g., cause/effect, part/whole, item/category) to better understand each of the words.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218184,
                        "StandardName":"L.6.5c",
                        "StandardDescription":"Distinguish among the connotations (associations) of words with similar denotations (definitions) (e.g., stingy, scrimping, economical, unwasteful, thrifty).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218743,
                        "StandardName":"RL.6.4",
                        "StandardDescription":"Determine the meaning of words and phrases as they are used in a text, including figurative and connotative meanings; analyze the impact of a specific word choice on meaning and tone.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218744,
                        "StandardName":"RL.6.5",
                        "StandardDescription":"Analyze how a particular sentence, chapter, scene, or stanza fits into the overall structure of a text and contributes to the development of the theme, setting, or plot.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218745,
                        "StandardName":"RL.6.6",
                        "StandardDescription":"Explain how an author develops the point of view of the narrator or speaker in a text.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218747,
                        "StandardName":"RL.6.7",
                        "StandardDescription":"Compare and contrast the experience of reading a story, drama, or poem to listening to or viewing an audio, video, or live version of the text, including contrasting what they \"see\" and \"hear\" when reading the text to what they perceive when they listen or watch.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218749,
                        "StandardName":"RL.6.9",
                        "StandardDescription":"Compare and contrast texts in different forms or genres (e.g., stories and poems; historical novels and fantasy stories) in terms of their approaches to similar themes and topics.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218751,
                        "StandardName":"RL.6.10",
                        "StandardDescription":"By the end of the year, read and comprehend literature, including stories, dramas, and poems, in the grades 6—8 text complexity band proficiently, with scaffolding as needed at the high end of the range.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218755,
                        "StandardName":"RI.6.2",
                        "StandardDescription":"Determine a central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218756,
                        "StandardName":"RI.6.3",
                        "StandardDescription":"Analyze in detail how a key individual, event, or idea is introduced, illustrated, and elaborated in a text (e.g., through examples or anecdotes).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218758,
                        "StandardName":"RI.6.4",
                        "StandardDescription":"Determine the meaning of words and phrases as they are used in a text, including figurative, connotative, and technical meanings.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218759,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218760,
                        "StandardName":"RI.6.6",
                        "StandardDescription":"Determine an author's point of view or purpose in a text and explain how it is conveyed in the text.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218762,
                        "StandardName":"RI.6.7",
                        "StandardDescription":"Integrate information presented in different media or formats (e.g., visually, quantitatively) as well as in words to develop a coherent understanding of a topic or issue.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218763,
                        "StandardName":"RI.6.8",
                        "StandardDescription":"Trace and evaluate the argument and specific claims in a text, distinguishing claims that are supported by reasons and evidence from claims that are not.",
                        "NeedsAttention":false,
                        "LessonID":130754
                     },
                     {
                        "StandardID":1218764,
                        "StandardName":"RI.6.9",
                        "StandardDescription":"Compare and contrast one author's presentation of events with that of another (e.g., a memoir written by and a biography on the same person).",
                        "NeedsAttention":false,
                        "LessonID":130754
                     }
                  ],
                  "ImagePath":"GenericExam.jpg",
                  "IsFormativeAssessment":true
               }
            ]
         },
         {
            "Sequence":2,
            "GroupName":"Reading Standards for Literature",
            "Hide":false,
            "Items":[
               {
                  "IsDiagnosticExam": false,
                  "Sequence":3,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Evaluating Text: Central Idea, Supporting Details & Precise/Vague Language",
                  "CurriculumItemID":1022084,
                  "AssignmentID":null,
                  "LessonID":107441,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  StudentConsumerCurriculumID: 1,
                  "StandardsGrowth":[
                     {
                        "StandardID":6268,
                        "StandardName":"1",
                        "StandardDescription":"Evaluate information, ideas, opinions, and themes in texts",
                        "NeedsAttention":false,
                        "LessonID":107441
                     },
                     {
                        "StandardID":662954,
                        "StandardName":"RL.6.2",
                        "StandardDescription":"Determine a theme or central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":107441
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":4,
                  "LessonDescription":"",
                  "CanStart":true,
                  "IsDiagnosticExam": false,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identify the Theme",
                  "CurriculumItemID":1022085,
                  "AssignmentID":null,
                  "LessonID":82871,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":662954,
                        "StandardName":"RL.6.2",
                        "StandardDescription":"Determine a theme or central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":82871
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":5,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Distinguish Between Major and Minor Characters",
                  "CurriculumItemID":1022086,
                  "AssignmentID":null,
                  "LessonID":87361,
                  "IsDiagnosticExam": false,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":662955,
                        "StandardName":"RL.6.3",
                        "StandardDescription":"Describe how a particular story's or drama's plot unfolds in a series of episodes as well as how the characters respond or change as the plot moves toward a resolution.",
                        "NeedsAttention":false,
                        "LessonID":87361
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":6,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identify Literary Elements",
                  "CurriculumItemID":1022087,
                  "AssignmentID":null,
                  "LessonID":87449,
                  "IsDiagnosticExam": false,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8778,
                        "StandardName":"6",
                        "StandardDescription":"Identify literary elements",
                        "NeedsAttention":false,
                        "LessonID":87449
                     },
                     {
                        "StandardID":662955,
                        "StandardName":"RL.6.3",
                        "StandardDescription":"Describe how a particular story's or drama's plot unfolds in a series of episodes as well as how the characters respond or change as the plot moves toward a resolution.",
                        "NeedsAttention":false,
                        "LessonID":87449
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":7,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identify the Components of a Plot",
                  "CurriculumItemID":1022088,
                  "AssignmentID":null,
                  "LessonID":82302,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662955,
                        "StandardName":"RL.6.3",
                        "StandardDescription":"Describe how a particular story's or drama's plot unfolds in a series of episodes as well as how the characters respond or change as the plot moves toward a resolution.",
                        "NeedsAttention":false,
                        "LessonID":82302
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":8,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Creating Feelings in Text",
                  "CurriculumItemID":1022089,
                  "AssignmentID":null,
                  "LessonID":87441,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8785,
                        "StandardName":"13",
                        "StandardDescription":"Author’s use of language creates images or feelings",
                        "NeedsAttention":false,
                        "LessonID":87441
                     },
                     {
                        "StandardID":662957,
                        "StandardName":"RL.6.4",
                        "StandardDescription":"Determine the meaning of words and phrases as they are used in a text, including figurative and connotative meanings; analyze the impact of a specific word choice on meaning and tone.",
                        "NeedsAttention":false,
                        "LessonID":87441
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":9,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Literary Terms and Author's Message",
                  "CurriculumItemID":1022090,
                  "AssignmentID":null,
                  "LessonID":87442,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8779,
                        "StandardName":"7",
                        "StandardDescription":"Recognize how the author uses literary devices",
                        "NeedsAttention":false,
                        "LessonID":87442
                     },
                     {
                        "StandardID":662957,
                        "StandardName":"RL.6.4",
                        "StandardDescription":"Determine the meaning of words and phrases as they are used in a text, including figurative and connotative meanings; analyze the impact of a specific word choice on meaning and tone.",
                        "NeedsAttention":false,
                        "LessonID":87442
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":10,
                  "LessonDescription":"",
                  "CanStart":false,
                  "CanContinue":false,
                  "CanRetake":true,
                  "LessonName":"Structural Elements of Poetry",
                  "CurriculumItemID":1022091,
                  "AssignmentID":4,
                  "LessonID":87367,
                  "LessonGrade":"80",
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":true,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":4,
                  "IsDiagnosticExam": false,
                  "Attempts":[
                     {
                        SentBack: false,
                        Graded: true,
                        SubmittedAsComplete: true,
                        Grade: "50",
                        AttemptID: 111,
                        Status: "Graded",
                        CompleteDate: "11/11/11",
                        CurriculumItemID: 1,
                        Sequence: 1,
                        AssignmentID: 2,
                        LessonID: 22,
                        LessonName: "It's a name"
                     }
                  ],
                  "StandardsGrowth":[
                     {
                        "StandardID":662958,
                        "StandardName":"RL.6.5",
                        "StandardDescription":"Analyze how a particular sentence, chapter, scene, or stanza fits into the overall structure of a text and contributes to the development of the theme, setting, or plot.",
                        "NeedsAttention":false,
                        "LessonID":87367
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":11,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Author's Point of View",
                  "CurriculumItemID":1022092,
                  "AssignmentID":null,
                  "LessonID":84771,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8783,
                        "StandardName":"11",
                        "StandardDescription":"Identify the author’s point of view",
                        "NeedsAttention":false,
                        "LessonID":84771
                     },
                     {
                        "StandardID":662959,
                        "StandardName":"RL.6.6",
                        "StandardDescription":"Explain how an author develops the point of view of the narrator or speaker in a text.",
                        "NeedsAttention":false,
                        "LessonID":84771
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":12,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Various Genres",
                  "CurriculumItemID":1022093,
                  "AssignmentID":null,
                  "LessonID":87448,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8774,
                        "StandardName":"2",
                        "StandardDescription":"Define characteristics of different genres",
                        "NeedsAttention":false,
                        "LessonID":87448
                     },
                     {
                        "StandardID":662964,
                        "StandardName":"RL.6.9",
                        "StandardDescription":"Compare and contrast texts in different forms or genres (e.g., stories and poems; historical novels and fantasy stories) in terms of their approaches to similar themes and topics.",
                        "NeedsAttention":false,
                        "LessonID":87448
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               }
            ]
         },
         {
            "Sequence":13,
            "GroupName":"Reading Standards for Informational Text",
            "Hide":false,
            "Items":[
               {
                  "Sequence":14,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Distinguish Fact from Opinion in Persuasive Text",
                  "CurriculumItemID":1022095,
                  "AssignmentID":null,
                  "LessonID":84061,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  StudentConsumerCurriculumID: 1,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662973,
                        "StandardName":"RI.6.1",
                        "StandardDescription":"Cite textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.",
                        "NeedsAttention":false,
                        "LessonID":84061
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":15,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Draw Conclusions and Make Inferences",
                  "CurriculumItemID":1022096,
                  "AssignmentID":null,
                  "LessonID":87234,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8771,
                        "StandardName":"17",
                        "StandardDescription":"Draw conclusions and make inferences",
                        "NeedsAttention":false,
                        "LessonID":87234
                     },
                     {
                        "StandardID":662973,
                        "StandardName":"RI.6.1",
                        "StandardDescription":"Cite textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.",
                        "NeedsAttention":false,
                        "LessonID":87234
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":16,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identify Information That is Implied Rather Than Stated",
                  "CurriculumItemID":1022097,
                  "AssignmentID":null,
                  "LessonID":87379,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8764,
                        "StandardName":"10",
                        "StandardDescription":"Implied and state information",
                        "NeedsAttention":false,
                        "LessonID":87379
                     },
                     {
                        "StandardID":662973,
                        "StandardName":"RI.6.1",
                        "StandardDescription":"Cite textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.",
                        "NeedsAttention":false,
                        "LessonID":87379
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":17,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Knowledge of Structure, Content and Vocab",
                  "CurriculumItemID":1022098,
                  "AssignmentID":null,
                  "LessonID":107397,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8769,
                        "StandardName":"15",
                        "StandardDescription":"Use knowledge of structure, content, and vocabulary",
                        "NeedsAttention":false,
                        "LessonID":107397
                     },
                     {
                        "StandardID":662973,
                        "StandardName":"RI.6.1",
                        "StandardDescription":"Cite textual evidence to support analysis of what the text says explicitly as well as inferences drawn from the text.",
                        "NeedsAttention":false,
                        "LessonID":107397
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":18,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Main Idea - Relevant vs. Irrelevant Information",
                  "CurriculumItemID":1022099,
                  "AssignmentID":null,
                  "LessonID":87387,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8767,
                        "StandardName":"13",
                        "StandardDescription":"Identify main ideas and supporting details",
                        "NeedsAttention":false,
                        "LessonID":87387
                     },
                     {
                        "StandardID":662974,
                        "StandardName":"RI.6.2",
                        "StandardDescription":"Determine a central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":87387
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":19,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Main Idea and Critical Details of Expository Text",
                  "CurriculumItemID":1022100,
                  "AssignmentID":null,
                  "LessonID":87297,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662974,
                        "StandardName":"RI.6.2",
                        "StandardDescription":"Determine a central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":87297
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":20,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Main Ideas and Supporting Details",
                  "CurriculumItemID":1022101,
                  "AssignmentID":null,
                  "LessonID":87386,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8767,
                        "StandardName":"13",
                        "StandardDescription":"Identify main ideas and supporting details",
                        "NeedsAttention":false,
                        "LessonID":87386
                     },
                     {
                        "StandardID":662974,
                        "StandardName":"RI.6.2",
                        "StandardDescription":"Determine a central idea of a text and how it is conveyed through particular details; provide a summary of the text distinct from personal opinions or judgments.",
                        "NeedsAttention":false,
                        "LessonID":87386
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":21,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Functional Text",
                  "CurriculumItemID":1022102,
                  "AssignmentID":null,
                  "LessonID":87281,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  StudentConsumerCurriculumID: 1,
                  "StandardsGrowth":[
                     {
                        "StandardID":8758,
                        "StandardName":"4",
                        "StandardDescription":"Read the steps in a procedure",
                        "NeedsAttention":false,
                        "LessonID":87281
                     },
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":87281
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":22,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identifying Text Features in Functional Text",
                  "CurriculumItemID":1022103,
                  "AssignmentID":null,
                  "LessonID":81666,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":81666
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":23,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Locate Details",
                  "CurriculumItemID":1022104,
                  "AssignmentID":null,
                  "LessonID":87276,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8758,
                        "StandardName":"4",
                        "StandardDescription":"Read the steps in a procedure",
                        "NeedsAttention":false,
                        "LessonID":87276
                     },
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":87276
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":24,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Recognize Organizational Formats",
                  "CurriculumItemID":1022105,
                  "AssignmentID":null,
                  "LessonID":87375,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "IsDiagnosticExam": false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8761,
                        "StandardName":"7",
                        "StandardDescription":"Recognize organizational formats",
                        "NeedsAttention":false,
                        "LessonID":87375
                     },
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":87375
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":25,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Text Features",
                  "CurriculumItemID":1022106,
                  "AssignmentID":null,
                  "LessonID":87377,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8760,
                        "StandardName":"6",
                        "StandardDescription":"Use text features",
                        "NeedsAttention":false,
                        "LessonID":87377
                     },
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":87377
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":26,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Use Text Features to Understand Informational Texts",
                  "CurriculumItemID":1022107,
                  "AssignmentID":null,
                  "LessonID":87376,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  StudentConsumerCurriculumID: 1,
                  "StandardsGrowth":[
                     {
                        "StandardID":8760,
                        "StandardName":"6",
                        "StandardDescription":"Use text features",
                        "NeedsAttention":false,
                        "LessonID":87376
                     },
                     {
                        "StandardID":662978,
                        "StandardName":"RI.6.5",
                        "StandardDescription":"Analyze how a particular sentence, paragraph, chapter, or section fits into the overall structure of a text and contributes to the development of the ideas.",
                        "NeedsAttention":false,
                        "LessonID":87376
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":27,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Author's Purpose in Writing",
                  "CurriculumItemID":1022108,
                  "AssignmentID":null,
                  "LessonID":84087,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662979,
                        "StandardName":"RI.6.6",
                        "StandardDescription":"Determine an author's point of view or purpose in a text and explain how it is conveyed in the text.",
                        "NeedsAttention":false,
                        "LessonID":84087
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":28,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Identify the Author's Purpose (Expository Text)",
                  "CurriculumItemID":1022109,
                  "AssignmentID":null,
                  "LessonID":81574,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662979,
                        "StandardName":"RI.6.6",
                        "StandardDescription":"Determine an author's point of view or purpose in a text and explain how it is conveyed in the text.",
                        "NeedsAttention":false,
                        "LessonID":81574
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":29,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Condense, Combine, or Categorize New Information",
                  "CurriculumItemID":1022110,
                  "AssignmentID":null,
                  "LessonID":87384,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8770,
                        "StandardName":"16",
                        "StandardDescription":"Condense, combine, or categorize new information",
                        "NeedsAttention":false,
                        "LessonID":87384
                     },
                     {
                        "StandardID":662981,
                        "StandardName":"RI.6.7",
                        "StandardDescription":"Integrate information presented in different media or formats (e.g., visually, quantitatively) as well as in words to develop a coherent understanding of a topic or issue.",
                        "NeedsAttention":false,
                        "LessonID":87384
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":30,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Interpret Graphic Features",
                  "CurriculumItemID":1022111,
                  "AssignmentID":null,
                  "LessonID":81575,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":662981,
                        "StandardName":"RI.6.7",
                        "StandardDescription":"Integrate information presented in different media or formats (e.g., visually, quantitatively) as well as in words to develop a coherent understanding of a topic or issue.",
                        "NeedsAttention":false,
                        "LessonID":81575
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":31,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Locating Reference Sources",
                  "CurriculumItemID":1022112,
                  "AssignmentID":null,
                  "LessonID":87537,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":662981,
                        "StandardName":"RI.6.7",
                        "StandardDescription":"Integrate information presented in different media or formats (e.g., visually, quantitatively) as well as in words to develop a coherent understanding of a topic or issue.",
                        "NeedsAttention":false,
                        "LessonID":87537
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":32,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Table of Contents and Indexes",
                  "CurriculumItemID":1022113,
                  "AssignmentID":null,
                  "LessonID":87536,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8756,
                        "StandardName":"2",
                        "StandardDescription":"Use the table of contents and indexes",
                        "NeedsAttention":false,
                        "LessonID":87536
                     },
                     {
                        "StandardID":662981,
                        "StandardName":"RI.6.7",
                        "StandardDescription":"Integrate information presented in different media or formats (e.g., visually, quantitatively) as well as in words to develop a coherent understanding of a topic or issue.",
                        "NeedsAttention":false,
                        "LessonID":87536
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":33,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Evaluate Text: Facts, Opinions and Exaggerations",
                  "CurriculumItemID":1022114,
                  "AssignmentID":null,
                  "LessonID":87479,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":6268,
                        "StandardName":"1",
                        "StandardDescription":"Evaluate information, ideas, opinions, and themes in texts",
                        "NeedsAttention":false,
                        "LessonID":87479
                     },
                     {
                        "StandardID":662982,
                        "StandardName":"RI.6.8",
                        "StandardDescription":"Trace and evaluate the argument and specific claims in a text, distinguishing claims that are supported by reasons and evidence from claims that are not.",
                        "NeedsAttention":false,
                        "LessonID":87479
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":34,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Fact and Opinion",
                  "CurriculumItemID":1022115,
                  "AssignmentID":null,
                  "LessonID":87535,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8763,
                        "StandardName":"9",
                        "StandardDescription":"Distinguish between fact and opinion",
                        "NeedsAttention":false,
                        "LessonID":87535
                     },
                     {
                        "StandardID":662982,
                        "StandardName":"RI.6.8",
                        "StandardDescription":"Trace and evaluate the argument and specific claims in a text, distinguishing claims that are supported by reasons and evidence from claims that are not.",
                        "NeedsAttention":false,
                        "LessonID":87535
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":35,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Facts and Opinions",
                  "CurriculumItemID":1022116,
                  "AssignmentID":null,
                  "LessonID":87378,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "IsDiagnosticExam": false,
                  "StandardsGrowth":[
                     {
                        "StandardID":8763,
                        "StandardName":"9",
                        "StandardDescription":"Distinguish between fact and opinion",
                        "NeedsAttention":false,
                        "LessonID":87378
                     },
                     {
                        "StandardID":662982,
                        "StandardName":"RI.6.8",
                        "StandardDescription":"Trace and evaluate the argument and specific claims in a text, distinguishing claims that are supported by reasons and evidence from claims that are not.",
                        "NeedsAttention":false,
                        "LessonID":87378
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":36,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Persuasive Strategies",
                  "CurriculumItemID":1022117,
                  "AssignmentID":null,
                  "LessonID":85758,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "IsDiagnosticExam": false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":662982,
                        "StandardName":"RI.6.8",
                        "StandardDescription":"Trace and evaluate the argument and specific claims in a text, distinguishing claims that are supported by reasons and evidence from claims that are not.",
                        "NeedsAttention":false,
                        "LessonID":85758
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               }
            ]
         },
         {
            "Sequence":37,
            "GroupName":"Language Standards",
            "Hide":false,
            "Items":[
               {
                  "Sequence":38,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Pronouns",
                  "CurriculumItemID":1022119,
                  "AssignmentID":null,
                  "LessonID":111283,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "IsDiagnosticExam": false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":663135,
                        "StandardName":"L.6.1",
                        "StandardDescription":"Demonstrate command of the conventions of standard English grammar and usage when writing or speaking.",
                        "NeedsAttention":false,
                        "LessonID":111283
                     },
                     {
                        "StandardID":663136,
                        "StandardName":"L.6.1.a",
                        "StandardDescription":"Ensure that pronouns are in the proper case (subjective, objective, possessive).",
                        "NeedsAttention":false,
                        "LessonID":111283
                     },
                     {
                        "StandardID":663137,
                        "StandardName":"L.6.1.b",
                        "StandardDescription":"Use intensive pronouns (e.g., myself, ourselves).",
                        "NeedsAttention":false,
                        "LessonID":111283
                     },
                     {
                        "StandardID":663138,
                        "StandardName":"L.6.1.c",
                        "StandardDescription":"Recognize and correct inappropriate shifts in pronoun number and person.",
                        "NeedsAttention":false,
                        "LessonID":111283
                     },
                     {
                        "StandardID":663139,
                        "StandardName":"L.6.1.d",
                        "StandardDescription":"Recognize and correct vague pronouns (i.e., ones with unclear or ambiguous antecedents).",
                        "NeedsAttention":false,
                        "LessonID":111283
                     },
                     {
                        "StandardID":663140,
                        "StandardName":"L.6.1.e",
                        "StandardDescription":"Recognize variations from standard English in their own and others' writing and speaking, and identify and use strategies to improve expression in conventional language.",
                        "NeedsAttention":false,
                        "LessonID":111283
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":39,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Context Clues: Unfamiliar Words",
                  "CurriculumItemID":1022124,
                  "AssignmentID":null,
                  "LessonID":87283,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8802,
                        "StandardName":"10",
                        "StandardDescription":"Determine the meaning of unfamiliar words",
                        "NeedsAttention":false,
                        "LessonID":87283
                     },
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":87283
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":87283
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":87283
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":87283
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":87283
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":40,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Effect of Root Words and Affixes",
                  "CurriculumItemID":1022125,
                  "AssignmentID":null,
                  "LessonID":87239,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8798,
                        "StandardName":"6",
                        "StandardDescription":"Use word structure knowledge",
                        "NeedsAttention":false,
                        "LessonID":87239
                     },
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":87239
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":87239
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":87239
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":87239
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":87239
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":41,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Meanings and Features of Words",
                  "CurriculumItemID":1022126,
                  "AssignmentID":null,
                  "LessonID":87284,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "IsDiagnosticExam": false,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8802,
                        "StandardName":"10",
                        "StandardDescription":"Determine the meaning of unfamiliar words",
                        "NeedsAttention":false,
                        "LessonID":87284
                     },
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":87284
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":87284
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":87284
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":87284
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":87284
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":42,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Multiple Meaning Words",
                  "CurriculumItemID":1022127,
                  "AssignmentID":null,
                  "LessonID":81583,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "IsDiagnosticExam": false,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  StudentConsumerCurriculumID: 1,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":81583
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":81583
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":81583
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":81583
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":81583
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               },
               {
                  "Sequence":43,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Thesaurus: Synonyms and Antonyms",
                  "CurriculumItemID":1022128,
                  "AssignmentID":null,
                  "LessonID":87440,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  StudentConsumerCurriculumID: 1,
                  "CompletedWithProficiency":false,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":8803,
                        "StandardName":"11",
                        "StandardDescription":"Use a thesaurus",
                        "NeedsAttention":false,
                        "LessonID":87440
                     },
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":87440
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":87440
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":87440
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":87440
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":87440
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false,
                  "IsDiagnosticExam": false
               },
               {
                  "Sequence":44,
                  "LessonDescription":"",
                  "CanStart":true,
                  "CanContinue":false,
                  "CanRetake":false,
                  "LessonName":"Use Context to Identify Multiple Meaning Words",
                  "CurriculumItemID":1022129,
                  "AssignmentID":null,
                  "LessonID":92417,
                  "LessonGrade":null,
                  "ExternalUrl":"/LearningContent/StudentAssignmentViewer.aspx?AssignmentID=",
                  "Suggested":false,
                  "HasCompletedAttempt":false,
                  "CompletedWithProficiency":false,
                  "IsDiagnosticExam": false,
                  StudentConsumerCurriculumID: 1,
                  "CurrentAttemptId":null,
                  "Attempts":null,
                  "StandardsGrowth":[
                     {
                        "StandardID":663149,
                        "StandardName":"L.6.4",
                        "StandardDescription":"Determine or clarify the meaning of unknown and multiple-meaning words and phrases based on grade 6 reading and content, choosing flexibly from a range of strategies.",
                        "NeedsAttention":false,
                        "LessonID":92417
                     },
                     {
                        "StandardID":663150,
                        "StandardName":"L.6.4.a",
                        "StandardDescription":"Use context (e.g., the overall meaning of a sentence or paragraph; a word's position or function in a sentence) as a clue to the meaning of a word or phrase.",
                        "NeedsAttention":false,
                        "LessonID":92417
                     },
                     {
                        "StandardID":663151,
                        "StandardName":"L.6.4.b",
                        "StandardDescription":"Use common, grade-appropriate Greek or Latin affixes and roots as clues to the meaning of a word (e.g., audience, auditory, audible).",
                        "NeedsAttention":false,
                        "LessonID":92417
                     },
                     {
                        "StandardID":663152,
                        "StandardName":"L.6.4.c",
                        "StandardDescription":"Consult reference materials (e.g., dictionaries, glossaries, thesauruses), both print and digital, to find the pronunciation of a word or determine or clarify its precise meaning or its part of speech.",
                        "NeedsAttention":false,
                        "LessonID":92417
                     },
                     {
                        "StandardID":663153,
                        "StandardName":"L.6.4.d",
                        "StandardDescription":"Verify the preliminary determination of the meaning of a word or phrase (e.g., by checking the inferred meaning in context or in a dictionary).",
                        "NeedsAttention":false,
                        "LessonID":92417
                     }
                  ],
                  "ImagePath":"ElemEnglish.jpg",
                  "IsFormativeAssessment":false
               }
            ]
         }
      ]
   };

  
 public globalStandards: StandardsGrowthReportModel = {
   "Standards":[
      {
         "StandardName":"5.N.16",
         "StandardDescription":"Use a variety of strategies to multiply three-digit by three-digit numbers",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Multiply Multi-Digit",
               "Sequence":18,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334055,
                     "AssignmentID":1517588,
                     "Grade":"90",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.N.17",
         "StandardDescription":"Use a variety of strategies to divide three-digit numbers by one- and two-digit numbers",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multi-Digit Division",
               "Sequence":19,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.5",
         "StandardDescription":"Relate volume to the operations of multiplication",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.2",
         "StandardDescription":"Make a line plot",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Solve Problems Using Line Plots ",
               "Sequence":24,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.OA.3",
         "StandardDescription":"Generate two numerical patterns",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Analyzing Patterns and Relationships",
               "Sequence":6,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.4",
         "StandardDescription":"Measure volumes",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume ",
               "Sequence":25,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.1",
         "StandardDescription":"Recognize that in a multi-digit number",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":50,
         "LessonProgress":[
            {
               "LessonName":"Base Ten Place Value -Thousands",
               "Sequence":8,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334051,
                     "AssignmentID":1517584,
                     "Grade":"100",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Decimals to Fractions",
               "Sequence":9,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.2",
         "StandardDescription":"Explain patterns in the number of zeros",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Exponential Form",
               "Sequence":10,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"More With Exponents",
               "Sequence":11,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying and Dividing Multiples of 10 and 100",
               "Sequence":12,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.5",
         "StandardDescription":"Fluently multiply multi-digit whole numbers",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Multiply Multi-Digit",
               "Sequence":18,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334055,
                     "AssignmentID":1517588,
                     "Grade":"90",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.6",
         "StandardDescription":"Find whole-number quotients",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multi-Digit Division",
               "Sequence":19,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.7",
         "StandardDescription":"Add, subtract, multiply, and divide decimals",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add, Subtract, Multiply and Divide Decimals",
               "Sequence":20,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.OA.2",
         "StandardDescription":"Write simple expressions",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Writing Algebraic Expressions",
               "Sequence":5,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334056,
                     "AssignmentID":1517589,
                     "Grade":null,
                     "Status":"Started",
                     "CompleteDate":null
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.OA.1",
         "StandardDescription":"Use parentheses, brackets, or braces in numerical expressions",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations",
               "Sequence":3,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order of Operations with Decimals and Fractions",
               "Sequence":4,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334050,
                     "AssignmentID":1517583,
                     "Grade":"60",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.3",
         "StandardDescription":"Read, write, and compare decimals to thousandths",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.4",
         "StandardDescription":"Use place value understanding to round decimals",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Rounding to Hundredths",
               "Sequence":17,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.1",
         "StandardDescription":"Convert among different-sized standard measurement unit",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Conversions Within Measurement Systems",
               "Sequence":22,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334054,
                     "AssignmentID":1517587,
                     "Grade":"17",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Converting Units",
               "Sequence":23,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334053,
                     "AssignmentID":1517586,
                     "Grade":"38",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NF.5",
         "StandardDescription":"Interpret multiplication as scaling",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.4",
         "StandardDescription":"Classify two-dimensional figures",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Angles",
               "Sequence":34,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Classifying Triangles",
               "Sequence":35,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Congruent and Similar Figures",
               "Sequence":36,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Parts of a Right Triangle",
               "Sequence":37,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.1",
         "StandardDescription":"Add and subtract fractions with unlike denominators",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add & Subtract Mixed Numbers with Like Denominators",
               "Sequence":39,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.2",
         "StandardDescription":"Solve word problems",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Addition and Subtraction Word Problems with Fractions ",
               "Sequence":40,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.4",
         "StandardDescription":"Multiply a fraction",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.1",
         "StandardDescription":"Use a pair of perpendicular number line",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Coordinate Plane",
               "Sequence":30,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.2",
         "StandardDescription":"Represent real world and mathematical problems",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Represent Real World Data in the Coordinate Plane",
               "Sequence":31,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.3",
         "StandardDescription":"Understand that attributes  of two-dimensional figures",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Quadrilaterals",
               "Sequence":32,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Naming Shapes",
               "Sequence":33,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.6",
         "StandardDescription":"Solve real world problems",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying Fractions and Mixed Numbers",
               "Sequence":45,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.7",
         "StandardDescription":"Divide unit fractions",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"7.G.5",
         "StandardDescription":"Identify the right angle, hypotenuse, and legs of a right triangle",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Parts of a Right Triangle",
               "Sequence":37,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.N.3",
         "StandardDescription":"Understand the place value structure",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Base Ten Place Value -Thousands",
               "Sequence":8,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334051,
                     "AssignmentID":1517584,
                     "Grade":"100",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.N.8",
         "StandardDescription":"Read, write, and order decimals",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.N.24",
         "StandardDescription":"Round numbers to the nearest hundredth and up to 10,000\n",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Rounding to Hundredths",
               "Sequence":17,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.N.18",
         "StandardDescription":"Evaluate an arithmetic expression using order of operations including multiplication, division, addition, subtraction and parentheses",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations",
               "Sequence":3,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.N.22",
         "StandardDescription":"Add and subtract mixed numbers with like denominators",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add & Subtract Mixed Numbers with Like Denominators",
               "Sequence":39,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.N.23",
         "StandardDescription":"Use a variety of strategies to add, subtract, multiply, and divide decimals to thousandths",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add, Subtract, Multiply and Divide Decimals",
               "Sequence":20,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.A.2",
         "StandardDescription":"Verbal expressions into algebraic expressions",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Writing Algebraic Expressions",
               "Sequence":5,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334056,
                     "AssignmentID":1517589,
                     "Grade":null,
                     "Status":"Started",
                     "CompleteDate":null
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.G.4",
         "StandardDescription":"Classify quadrilaterals by properties of their angles and sides",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Quadrilaterals",
               "Sequence":32,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"4.M.1.2.6",
         "StandardDescription":"Apply order of operations with whole numbers",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations",
               "Sequence":3,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"4.M.4.1.3",
         "StandardDescription":"Describe and classify triangles",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Triangles",
               "Sequence":35,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"4.M.4.1.6",
         "StandardDescription":"Draw right, acute, obtuse, and straight angles",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Angles",
               "Sequence":34,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.M.1.2.2",
         "StandardDescription":" Multiply multi-digit whole numbers",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Multiply Multi-Digit",
               "Sequence":18,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334055,
                     "AssignmentID":1517588,
                     "Grade":"90",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.M.1.2.3",
         "StandardDescription":"Divide multi-digit whole numbers",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multi-Digit Division",
               "Sequence":19,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.M.1.2.5",
         "StandardDescription":"Simplify numerical expressions",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations with Decimals and Fractions",
               "Sequence":4,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334050,
                     "AssignmentID":1517583,
                     "Grade":"60",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.M.4.1.3",
         "StandardDescription":"Classify quadrilaterals",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Quadrilaterals",
               "Sequence":32,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"6.N.24",
         "StandardDescription":"Represent exponential form as repeated multiplication",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Exponential Form",
               "Sequence":10,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"6.N.25",
         "StandardDescription":"Evaluate expressions having exponents where the power is an exponent of one, two, or three",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"More With Exponents",
               "Sequence":11,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.OA.1",
         "StandardDescription":"Use parentheses, brackets, or braces in numerical expressions, and evaluate expressions with these symbols.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations",
               "Sequence":3,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order of Operations with Decimals and Fractions",
               "Sequence":4,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334050,
                     "AssignmentID":1517583,
                     "Grade":"60",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.OA.2",
         "StandardDescription":"Write simple expressions that record calculations with numbers, and interpret numerical expressions without evaluating them.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Writing Algebraic Expressions",
               "Sequence":5,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334056,
                     "AssignmentID":1517589,
                     "Grade":null,
                     "Status":"Started",
                     "CompleteDate":null
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.OA.3",
         "StandardDescription":"Generate two numerical patterns using two given rules. Identify apparent relationships between corresponding terms. Form ordered pairs consisting of corresponding terms from the two patterns, and graph the ordered pairs on a coordinate plane.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Analyzing Patterns and Relationships",
               "Sequence":6,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.1",
         "StandardDescription":"Recognize that in a multi-digit number, a digit in one place represents 10 times as much as it represents in the place to its right and 1/10 of what it represents in the place to its left.",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":50,
         "LessonProgress":[
            {
               "LessonName":"Base Ten Place Value -Thousands",
               "Sequence":8,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334051,
                     "AssignmentID":1517584,
                     "Grade":"100",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Decimals to Fractions",
               "Sequence":9,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.2",
         "StandardDescription":"Explain patterns in the number of zeros of the product when multiplying a number by powers of 10, and explain patterns in the placement of the decimal point when a decimal is multiplied or divided by a power of 10. Use whole-number exponents to denote powers of 10.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Exponential Form",
               "Sequence":10,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"More With Exponents",
               "Sequence":11,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying and Dividing Multiples of 10 and 100",
               "Sequence":12,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.3",
         "StandardDescription":"Read, write, and compare decimals to thousandths.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.3.a",
         "StandardDescription":"Read and write decimals to thousandths using base-ten numerals, number names, and expanded form, e.g., 347.392 = 3 × 100 + 4 × 10 + 7 × 1 + 3 × (1/10) + 9 × (1/100) + 2 × (1/1000).",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.3.b",
         "StandardDescription":"Compare two decimals to thousandths based on meanings of the digits in each place, using >, =, and < symbols to record the results of comparisons.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.4",
         "StandardDescription":"Use place value understanding to round decimals to any place.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Rounding to Hundredths",
               "Sequence":17,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.5",
         "StandardDescription":"Fluently multiply multi-digit whole numbers using the standard algorithm.",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Multiply Multi-Digit",
               "Sequence":18,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334055,
                     "AssignmentID":1517588,
                     "Grade":"90",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.6",
         "StandardDescription":"Find whole-number quotients of whole numbers with up to four-digit dividends and two-digit divisors, using strategies based on place value, the properties of operations, and/or the relationship between multiplication and division. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multi-Digit Division",
               "Sequence":19,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.7",
         "StandardDescription":"Add, subtract, multiply, and divide decimals to hundredths, using concrete models or drawings and strategies based on place value, properties of operations, and/or the relationship between addition and subtraction; relate the strategy to a written method and explain the reasoning used.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add, Subtract, Multiply and Divide Decimals",
               "Sequence":20,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.1",
         "StandardDescription":"Convert among different-sized standard measurement units within a given measurement system (e.g., convert 5 cm to 0.05 m), and use these conversions in solving multi-step, real world problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Conversions Within Measurement Systems",
               "Sequence":22,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334054,
                     "AssignmentID":1517587,
                     "Grade":"17",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Converting Units",
               "Sequence":23,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334053,
                     "AssignmentID":1517586,
                     "Grade":"38",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.MD.2",
         "StandardDescription":"Make a line plot to display a data set of measurements in fractions of a unit (1/2, 1/4, 1/8). Use operations on fractions for this grade to solve problems involving information presented in line plots.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Solve Problems Using Line Plots ",
               "Sequence":24,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.3.a",
         "StandardDescription":"A cube with side length 1 unit, called a \"unit cube,\" is said to have \"one cubic unit\" of volume, and can be used to measure volume.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.MD.3.b",
         "StandardDescription":"A solid figure which can be packed without gaps or overlaps using n unit cubes is said to have a volume of n cubic units.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.MD.4",
         "StandardDescription":"Measure volumes by counting unit cubes, using cubic cm, cubic in, cubic ft, and improvised units.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume ",
               "Sequence":25,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.5",
         "StandardDescription":"Relate volume to the operations of multiplication and addition and solve real world and mathematical problems involving volume.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.5.a",
         "StandardDescription":"Find the volume of a right rectangular prism with whole-number side lengths by packing it with unit cubes, and show that the volume is the same as would be found by multiplying the edge lengths, equivalently by multiplying the height by the area of the base. Represent threefold whole-number products as volumes, e.g., to represent the associative property of multiplication.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.5.b",
         "StandardDescription":"Apply the formulas V = l × w × h and V = b × h for rectangular prisms to find volumes of right rectangular prisms with whole-number edge lengths in the context of solving real world and mathematical problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.5.c",
         "StandardDescription":"Recognize volume as additive. Find volumes of solid figures composed of two non-overlapping right rectangular prisms by adding the volumes of the non-overlapping parts, applying this technique to solve real world problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.1",
         "StandardDescription":"Use a pair of perpendicular number lines, called axes, to define a coordinate system, with the intersection of the lines (the origin) arranged to coincide with the 0 on each line and a given point in the plane located by using an ordered pair of numbers, called its coordinates. Understand that the first number indicates how far to travel from the origin in the direction of one axis, and the second number indicates how far to travel in the direction of the second axis, with the convention that the names of the two axes and the coordinates correspond (e.g., x-axis and x-coordinate, y-axis and y-coordinate).",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Coordinate Plane",
               "Sequence":30,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.2",
         "StandardDescription":"Represent real world and mathematical problems by graphing points in the first quadrant of the coordinate plane, and interpret coordinate values of points in the context of the situation.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Represent Real World Data in the Coordinate Plane",
               "Sequence":31,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.3",
         "StandardDescription":"Understand that attributes belonging to a category of two-dimensional figures also belong to all subcategories of that category.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Quadrilaterals",
               "Sequence":32,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Naming Shapes",
               "Sequence":33,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.4",
         "StandardDescription":"Classify two-dimensional figures in a hierarchy based on properties.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Angles",
               "Sequence":34,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Classifying Triangles",
               "Sequence":35,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Congruent and Similar Figures",
               "Sequence":36,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Parts of a Right Triangle",
               "Sequence":37,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.1",
         "StandardDescription":"Add and subtract fractions with unlike denominators (including mixed numbers) by replacing given fractions with equivalent fractions in such a way as to produce an equivalent sum or difference of fractions with like denominators.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add & Subtract Mixed Numbers with Like Denominators",
               "Sequence":39,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.2",
         "StandardDescription":"Solve word problems involving addition and subtraction of fractions referring to the same whole, including cases of unlike denominators, e.g., by using visual fraction models or equations to represent the problem. Use benchmark fractions and number sense of fractions to estimate mentally and assess the reasonableness of answers.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Addition and Subtraction Word Problems with Fractions ",
               "Sequence":40,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.3",
         "StandardDescription":"Interpret a fraction as division of the numerator by the denominator (a/b = a ÷ b). Solve word problems involving division of whole numbers leading to answers in the form of fractions or mixed numbers, e.g., by using visual fraction models or equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.NF.4",
         "StandardDescription":"Apply and extend previous understandings of multiplication to multiply a fraction or whole number by a fraction.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.4.a",
         "StandardDescription":"Interpret the product (a/b) × q as a parts of a partition of q into b equal parts; equivalently, as the result of a sequence of operations a × q ÷ b.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.4.b",
         "StandardDescription":"Find the area of a rectangle with fractional side lengths by tiling it with unit squares of the appropriate unit fraction side lengths, and show that the area is the same as would be found by multiplying the side lengths. Multiply fractional side lengths to find areas of rectangles, and represent fraction products as rectangular areas.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.5",
         "StandardDescription":"Interpret multiplication as scaling (resizing), by:",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.5.a",
         "StandardDescription":"Comparing the size of a product to the size of one factor on the basis of the size of the other factor, without performing the indicated multiplication.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.5.b",
         "StandardDescription":"Explaining why multiplying a given number by a fraction greater than 1 results in a product greater than the given number (recognizing multiplication by whole numbers greater than 1 as a familiar case); explaining why multiplying a given number by a fraction less than 1 results in a product smaller than the given number; and relating the principle of fraction equivalence a/b = (n×a)/(n×b) to the effect of multiplying a/b by 1.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.6",
         "StandardDescription":"Solve real world problems involving multiplication of fractions and mixed numbers, e.g., by using visual fraction models or equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying Fractions and Mixed Numbers",
               "Sequence":45,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.7",
         "StandardDescription":"Apply and extend previous understandings of division to divide unit fractions by whole numbers and whole numbers by unit fractions.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.7.a",
         "StandardDescription":"Interpret division of a unit fraction by a non-zero whole number, and compute such quotients.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.7.b",
         "StandardDescription":"Interpret division of a whole number by a unit fraction, and compute such quotients.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.7.c",
         "StandardDescription":"Solve real world problems involving division of unit fractions by non-zero whole numbers and division of whole numbers by unit fractions, e.g., by using visual fraction models and equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.OA.A.1",
         "StandardDescription":"Use parentheses, brackets, or braces in numerical expressions, and evaluate expressions with these symbols.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Order of Operations",
               "Sequence":3,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order of Operations with Decimals and Fractions",
               "Sequence":4,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334050,
                     "AssignmentID":1517583,
                     "Grade":"60",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.OA.A.2",
         "StandardDescription":"Write simple expressions that record calculations with numbers, and interpret numerical expressions without evaluating them.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Writing Algebraic Expressions",
               "Sequence":5,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334056,
                     "AssignmentID":1517589,
                     "Grade":null,
                     "Status":"Started",
                     "CompleteDate":null
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.OA.B.3",
         "StandardDescription":"Generate two numerical patterns using two given rules. Identify apparent relationships between corresponding terms. Form ordered pairs consisting of corresponding terms from the two patterns, and graph the ordered pairs on a coordinate plane.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Analyzing Patterns and Relationships",
               "Sequence":6,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.1",
         "StandardDescription":"Recognize that in a multi-digit number, a digit in one place represents 10 times as much as it represents in the place to its right and 1/10 of what it represents in the place to its left.",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":50,
         "LessonProgress":[
            {
               "LessonName":"Base Ten Place Value -Thousands",
               "Sequence":8,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334051,
                     "AssignmentID":1517584,
                     "Grade":"100",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Decimals to Fractions",
               "Sequence":9,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.2",
         "StandardDescription":"Explain patterns in the number of zeros of the product when multiplying a number by powers of 10, and explain patterns in the placement of the decimal point when a decimal is multiplied or divided by a power of 10. Use whole-number exponents to denote powers of 10.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Exponential Form",
               "Sequence":10,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"More With Exponents",
               "Sequence":11,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying and Dividing Multiples of 10 and 100",
               "Sequence":12,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.3",
         "StandardDescription":"Read, write, and compare decimals to thousandths.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.3a",
         "StandardDescription":"Read and write decimals to thousandths using base-ten numerals, number names, and expanded form, e.g., 347.392 = 3 × 100 + 4 × 10 + 7 × 1 + 3 × (1/10) + 9 × (1/100) + 2 × (1/1000).",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.3b",
         "StandardDescription":"Compare two decimals to thousandths based on meanings of the digits in each place, using >, =, and < symbols to record the results of comparisons.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":13,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":14,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Compare and Order Decimals",
               "Sequence":15,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Order Decimals to Thousandths",
               "Sequence":16,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334052,
                     "AssignmentID":1517585,
                     "Grade":"11",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.A.4",
         "StandardDescription":"Use place value understanding to round decimals to any place.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Rounding to Hundredths",
               "Sequence":17,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.B.5",
         "StandardDescription":"Fluently multiply multi-digit whole numbers using the standard algorithm.",
         "Suggested":false,
         "ProficientLessons":1,
         "AchievementComplete":100,
         "LessonProgress":[
            {
               "LessonName":"Multiply Multi-Digit",
               "Sequence":18,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334055,
                     "AssignmentID":1517588,
                     "Grade":"90",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.NBT.B.6",
         "StandardDescription":"Find whole-number quotients of whole numbers with up to four-digit dividends and two-digit divisors, using strategies based on place value, the properties of operations, and/or the relationship between multiplication and division. Illustrate and explain the calculation by using equations, rectangular arrays, and/or area models.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multi-Digit Division",
               "Sequence":19,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NBT.B.7",
         "StandardDescription":"Add, subtract, multiply, and divide decimals to hundredths, using concrete models or drawings and strategies based on place value, properties of operations, and/or the relationship between addition and subtraction; relate the strategy to a written method and explain the reasoning used.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add, Subtract, Multiply and Divide Decimals",
               "Sequence":20,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.A.1",
         "StandardDescription":"Convert among different-sized standard measurement units within a given measurement system (e.g., convert 5 cm to 0.05 m), and use these conversions in solving multi-step, real world problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Conversions Within Measurement Systems",
               "Sequence":22,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334054,
                     "AssignmentID":1517587,
                     "Grade":"17",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            },
            {
               "LessonName":"Converting Units",
               "Sequence":23,
               "IsDiagnostic":false,
               "Attempts":[
                  {
                     "AttemptID":1334053,
                     "AssignmentID":1517586,
                     "Grade":"38",
                     "Status":"Graded",
                     "CompleteDate":"10/26/2021"
                  }
               ]
            }
         ]
      },
      {
         "StandardName":"5.MD.B.2",
         "StandardDescription":"Make a line plot to display a data set of measurements in fractions of a unit (1/2, 1/4, 1/8). Use operations on fractions for this grade to solve problems involving information presented in line plots.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Solve Problems Using Line Plots ",
               "Sequence":24,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.C.3a",
         "StandardDescription":"A cube with side length 1 unit, called a \"unit cube,\" is said to have \"one cubic unit\" of volume, and can be used to measure volume.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.MD.C.3b",
         "StandardDescription":"A solid figure which can be packed without gaps or overlaps using n unit cubes is said to have a volume of n cubic units.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.MD.C.4",
         "StandardDescription":"Measure volumes by counting unit cubes, using cubic cm, cubic in, cubic ft, and improvised units.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume ",
               "Sequence":25,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.C.5",
         "StandardDescription":"Relate volume to the operations of multiplication and addition and solve real world and mathematical problems involving volume.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.C.5a",
         "StandardDescription":"Find the volume of a right rectangular prism with whole-number side lengths by packing it with unit cubes, and show that the volume is the same as would be found by multiplying the edge lengths, equivalently by multiplying the height by the area of the base. Represent threefold whole-number products as volumes, e.g., to represent the associative property of multiplication.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.C.5b",
         "StandardDescription":"Apply the formulas V = l × w × h and V = b × h for rectangular prisms to find volumes of right rectangular prisms with whole-number edge lengths in the context of solving real world and mathematical problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.MD.C.5c",
         "StandardDescription":"Recognize volume as additive. Find volumes of solid figures composed of two non-overlapping right rectangular prisms by adding the volumes of the non-overlapping parts, applying this technique to solve real world problems.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":26,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":27,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Volume of a Rectangular Prism",
               "Sequence":28,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.A.1",
         "StandardDescription":"Use a pair of perpendicular number lines, called axes, to define a coordinate system, with the intersection of the lines (the origin) arranged to coincide with the 0 on each line and a given point in the plane located by using an ordered pair of numbers, called its coordinates. Understand that the first number indicates how far to travel from the origin in the direction of one axis, and the second number indicates how far to travel in the direction of the second axis, with the convention that the names of the two axes and the coordinates correspond (e.g., x-axis and x-coordinate, y-axis and y-coordinate).",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Coordinate Plane",
               "Sequence":30,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.A.2",
         "StandardDescription":"Represent real world and mathematical problems by graphing points in the first quadrant of the coordinate plane, and interpret coordinate values of points in the context of the situation.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Represent Real World Data in the Coordinate Plane",
               "Sequence":31,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.B.3",
         "StandardDescription":"Understand that attributes belonging to a category of two-dimensional figures also belong to all subcategories of that category.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Quadrilaterals",
               "Sequence":32,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Naming Shapes",
               "Sequence":33,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.G.B.4",
         "StandardDescription":"Classify two-dimensional figures in a hierarchy based on properties.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Classifying Angles",
               "Sequence":34,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Classifying Triangles",
               "Sequence":35,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Congruent and Similar Figures",
               "Sequence":36,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Parts of a Right Triangle",
               "Sequence":37,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.A.1",
         "StandardDescription":"Add and subtract fractions with unlike denominators (including mixed numbers) by replacing given fractions with equivalent fractions in such a way as to produce an equivalent sum or difference of fractions with like denominators.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Add & Subtract Mixed Numbers with Like Denominators",
               "Sequence":39,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.A.2",
         "StandardDescription":"Solve word problems involving addition and subtraction of fractions referring to the same whole, including cases of unlike denominators, e.g., by using visual fraction models or equations to represent the problem. Use benchmark fractions and number sense of fractions to estimate mentally and assess the reasonableness of answers.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Addition and Subtraction Word Problems with Fractions ",
               "Sequence":40,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.3",
         "StandardDescription":"Interpret a fraction as division of the numerator by the denominator (a/b = a ÷ b). Solve word problems involving division of whole numbers leading to answers in the form of fractions or mixed numbers, e.g., by using visual fraction models or equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            
         ]
      },
      {
         "StandardName":"5.NF.B.4",
         "StandardDescription":"Apply and extend previous understandings of multiplication to multiply a fraction or whole number by a fraction.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.4a",
         "StandardDescription":"Interpret the product (a/b) × q as a parts of a partition of q into b equal parts; equivalently, as the result of a sequence of operations a × q ÷ b.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.4b",
         "StandardDescription":"Find the area of a rectangle with fractional side lengths by tiling it with unit squares of the appropriate unit fraction side lengths, and show that the area is the same as would be found by multiplying the side lengths. Multiply fractional side lengths to find areas of rectangles, and represent fraction products as rectangular areas.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":41,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Fraction by a Fraction and a Whole Number ",
               "Sequence":42,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.5",
         "StandardDescription":"Interpret multiplication as scaling (resizing), by:",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.5a",
         "StandardDescription":"Comparing the size of a product to the size of one factor on the basis of the size of the other factor, without performing the indicated multiplication.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.5b",
         "StandardDescription":"Explaining why multiplying a given number by a fraction greater than 1 results in a product greater than the given number (recognizing multiplication by whole numbers greater than 1 as a familiar case); explaining why multiplying a given number by a fraction less than 1 results in a product smaller than the given number; and relating the principle of fraction equivalence a/b = (n×a)/(n×b) to the effect of multiplying a/b by 1.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":43,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Multiplying a Whole Number by a Fraction",
               "Sequence":44,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.6",
         "StandardDescription":"Solve real world problems involving multiplication of fractions and mixed numbers, e.g., by using visual fraction models or equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Multiplying Fractions and Mixed Numbers",
               "Sequence":45,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.7",
         "StandardDescription":"Apply and extend previous understandings of division to divide unit fractions by whole numbers and whole numbers by unit fractions.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.7a",
         "StandardDescription":"Interpret division of a unit fraction by a non-zero whole number, and compute such quotients.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.7b",
         "StandardDescription":"Interpret division of a whole number by a unit fraction, and compute such quotients.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      },
      {
         "StandardName":"5.NF.B.7c",
         "StandardDescription":"Solve real world problems involving division of unit fractions by non-zero whole numbers and division of whole numbers by unit fractions, e.g., by using visual fraction models and equations to represent the problem.",
         "Suggested":false,
         "ProficientLessons":0,
         "AchievementComplete":0,
         "LessonProgress":[
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":46,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":47,
               "IsDiagnostic":false,
               "Attempts":null
            },
            {
               "LessonName":"Dividing Fractions by Whole Numbers",
               "Sequence":48,
               "IsDiagnostic":false,
               "Attempts":null
            }
         ]
      }
   ]
};


}
